<template>
  <div>
    <div class="myInquirySearcher">
      <div class="firstLine">
        <div class="customizeIcon">{{titleName}}</div>
        <slot name="typeDiv"></slot>
      </div>
      <div class="myInquirySearcher-content">       
        <slot name="searchDiv"></slot>
      </div>
    </div>
    <div class="product_body restaurantB" ref="myInquiryExh">
      <slot name="dataDiv"></slot>
      <p class="loading" v-show="loading">
        <i class="el-icon-loading"></i>
      </p>
      <p class="noMore" v-show="isMore">没有更多结果了~</p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      loading:false,
      isMore:false,
    }
  },
  props:{
    titleName:{
      type:String,
      default:''
    }
  },
  mounted(){
    var _this=this
    this.$refs.myInquiryExh.addEventListener("scroll", function (event) {
      if (this.clientHeight + this.scrollTop > this.scrollHeight - 10&&!_this.loading&&!_this.isMore) {
        _this.$emit("loadData")
      }
    });
  }
}
</script>

<style lang="scss" scoped>
.myInquirySearcher{
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.4);
  padding-bottom: 0.05rem;
  .firstLine{
    display: flex;
    justify-content: space-between;
    .customizeIcon{
      width: 1.2rem;
      height: 0.4rem;
      background: #DB4E1A;
      text-align: center;
      line-height: 0.4rem;
      color: white;
      font-weight: bold;
    }
  }  
}
.myInquirySearcher-content{
  padding: 0.08rem 0.1rem;
}
// .product_body::-webkit-scrollbar {
//   display: none;/* 移动端、pad 上Safari，Chrome，隐藏滚动条 */
// }
.product_body{
  overflow-x: hidden;
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 5px;
  background: rgb(250, 250, 250);
  overflow-y: scroll;
  padding: 0 0.1rem;
  top: 1.8rem;
  // scrollbar-width: none; /* Firefox隐藏滚动条 */
  // -ms-overflow-style: none; /* Internet Explorer 10+隐藏滚动条 */
  .loading {
    height: 40px;
    text-align: center;
    font-size: 24px;
  }
  .noMore {
    height: 40px;
    text-align: center;
    font-size: 14px;
    color: #a8a8a8;
    line-height: 40px;
  }
}
</style>